import { Neighborhood } from '@/types'

/**
 * Kliniğin hizmet verdiği Karaköprü mahalleleri.
 *
 * Veri kaynakları — hiçbir değer tahmin edilmemiştir:
 *  - nüfus: TÜİK 2019 mahalle nüfusları (nufusu.com üzerinden)
 *  - koordinat: OpenStreetMap Nominatim
 *  - mesafe/süre: OSRM ile hesaplanan gerçek araç rotası (klinik adresine)
 *
 * Kırsal mahalleler listeye alınmamıştır; yalnızca Karaköprü'nün
 * yerleşik kent dokusunu oluşturan mahalleler yer alır.
 */
export const neighborhoods: Neighborhood[] = [
  {
    name: 'Seyrantepe',
    slug: 'seyrantepe',
    population: 27259,
    distanceKm: 3.3,
    driveMinutes: 7,
    lat: 37.2144511,
    lon: 38.7665132
  },
  {
    name: 'Doğukent',
    slug: 'dogukent',
    population: 25280,
    distanceKm: 4.0,
    driveMinutes: 6,
    lat: 37.2047125,
    lon: 38.8119504
  },
  {
    name: 'Akpıyar',
    slug: 'akpiyar',
    population: 24145,
    distanceKm: 0.7,
    driveMinutes: 1,
    lat: 37.2141848,
    lon: 38.793123
  },
  {
    name: 'Atakent',
    slug: 'atakent',
    population: 24112,
    distanceKm: 3.3,
    driveMinutes: 4,
    lat: 37.2278675,
    lon: 38.8047307
  },
  {
    name: 'Narlıkuyu',
    slug: 'narlikuyu',
    population: 17561,
    distanceKm: 3.2,
    driveMinutes: 5,
    lat: 37.2140735,
    lon: 38.8060564
  },
  {
    name: 'Şenevler',
    slug: 'senevler',
    population: 13556,
    distanceKm: 1.9,
    driveMinutes: 4,
    lat: 37.2205662,
    lon: 38.800253
  },
  {
    name: 'Ali Baba',
    slug: 'ali-baba',
    population: 12661,
    distanceKm: 2.5,
    driveMinutes: 3,
    lat: 37.1964228,
    lon: 38.8009741
  },
  {
    name: 'Karşıyaka',
    slug: 'karsiyaka',
    population: 11420,
    distanceKm: 3.2,
    driveMinutes: 4,
    lat: 37.1911763,
    lon: 38.7995453
  },
  {
    name: 'Akbayır',
    slug: 'akbayir',
    population: 11313,
    distanceKm: 3.1,
    driveMinutes: 4,
    lat: 37.1947459,
    lon: 38.808338
  },
  {
    name: 'Çankaya',
    slug: 'cankaya',
    population: 7983,
    distanceKm: 2.2,
    driveMinutes: 3,
    lat: 37.2091719,
    lon: 38.7987972
  },
  {
    name: 'Esentepe',
    slug: 'esentepe',
    population: 6414,
    distanceKm: 3.5,
    driveMinutes: 5,
    lat: 37.1836979,
    lon: 38.8028541
  },
  {
    name: 'Batıkent',
    slug: 'batikent',
    population: 3609,
    distanceKm: 1.1,
    driveMinutes: 2,
    lat: 37.2132145,
    lon: 38.7829796
  },
  {
    name: 'Güllübağ',
    slug: 'gullubag',
    population: 3255,
    distanceKm: 6.1,
    driveMinutes: 8,
    lat: 37.2281963,
    lon: 38.8232567
  },
  {
    name: 'Mehmetçik',
    slug: 'mehmetcik',
    population: 2993,
    distanceKm: 3.5,
    driveMinutes: 7,
    lat: 37.1973941,
    lon: 38.7731331
  }
]

export const findNeighborhood = (slug?: string): Neighborhood | undefined =>
  neighborhoods.find(n => n.slug === slug)

/** Toplam kapsanan nüfus — hizmet bölgesi metinlerinde kullanılır. */
export const coveredPopulation = neighborhoods.reduce((t, n) => t + n.population, 0)
